import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const MultipleDropzonePlaceholderIcon = svgProps => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116 29",
    height: getDefaultHeight(svgProps, 29),
    fill: "none",
    ...svgProps,
    children: [/*#__PURE__*/jsx("path", {
      d: "M25 5a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H29a4 4 0 0 1-4-4V5Z",
      fill: "#090B19",
      fillOpacity: ".06"
    }), /*#__PURE__*/jsx("path", {
      d: "M25 5a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H29a4 4 0 0 1-4-4V5Z",
      stroke: "#E5E6E7"
    }), /*#__PURE__*/jsx("path", {
      d: "M25 5a4 4 0 0 1 4-4h8c7.18 0 13 5.82 13 13v8a4 4 0 0 1-4 4H29a4 4 0 0 1-4-4V5Z",
      fill: "#090B19",
      fillOpacity: ".1"
    }), /*#__PURE__*/jsx("path", {
      d: "M38.512 15.18v3.96h-2.02v-3.96h-3.48v-1.84h3.48V9.52h2.02v3.82h3.48v1.84h-3.48Z",
      fill: "#fff"
    }), /*#__PURE__*/jsxs("g", {
      opacity: ".5",
      children: [/*#__PURE__*/jsx("path", {
        d: "M58 5a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H62a4 4 0 0 1-4-4V5Z",
        fill: "#090B19",
        fillOpacity: ".06"
      }), /*#__PURE__*/jsx("path", {
        d: "M58 5a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H62a4 4 0 0 1-4-4V5Z",
        stroke: "#E5E6E7"
      }), /*#__PURE__*/jsx("path", {
        d: "M58 5a4 4 0 0 1 4-4h8c7.18 0 13 5.82 13 13v8a4 4 0 0 1-4 4H62a4 4 0 0 1-4-4V5Z",
        fill: "#090B19",
        fillOpacity: ".1"
      }), /*#__PURE__*/jsx("path", {
        d: "M71.512 15.18v3.96h-2.02v-3.96h-3.48v-1.84h3.48V9.52h2.02v3.82h3.48v1.84h-3.48Z",
        fill: "#fff"
      })]
    }), /*#__PURE__*/jsxs("g", {
      opacity: ".2",
      children: [/*#__PURE__*/jsx("path", {
        d: "M91 5a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H95a4 4 0 0 1-4-4V5Z",
        fill: "#090B19",
        fillOpacity: ".06"
      }), /*#__PURE__*/jsx("path", {
        d: "M91 5a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H95a4 4 0 0 1-4-4V5Z",
        stroke: "#E5E6E7"
      }), /*#__PURE__*/jsx("path", {
        d: "M91 5a4 4 0 0 1 4-4h8c7.18 0 13 5.82 13 13v8a4 4 0 0 1-4 4H95a4 4 0 0 1-4-4V5Z",
        fill: "#090B19",
        fillOpacity: ".1"
      }), /*#__PURE__*/jsx("path", {
        d: "M104.512 15.18v3.96h-2.02v-3.96h-3.48v-1.84h3.48V9.52h2.02v3.82h3.48v1.84h-3.48Z",
        fill: "#fff"
      })]
    }), /*#__PURE__*/jsx("path", {
      d: "M16.392 6.014a1 1 0 0 0-.48-1.33L7.764.86a1 1 0 1 0-.85 1.81l7.243 3.399-3.398 7.242a1 1 0 1 0 1.811.85l3.822-8.148ZM4.87 26.568c-1.478-3.864-2.108-7.595-.792-10.94 1.307-3.318 4.644-6.53 11.749-9.098l-.68-1.881C7.764 7.316 3.818 10.828 2.217 14.896c-1.591 4.043-.754 8.363.784 12.386l1.869-.714Z",
      fill: "#E5E6E7"
    })]
  });
};

export { MultipleDropzonePlaceholderIcon };
//# sourceMappingURL=dropzone.multiple.js.map
